export const commonFormMixin = {
  props: ['formVisible', 'selRow', 'submitUrl'],
  data(){
    return {
      form: {}
    }
  },
  methods: {
    async submit() {
      if (typeof this.beforeSubmit === 'function') this.beforeSubmit();
      let valid = await this.$refs.form.validate().catch(() => {
      });
      if (!valid) return;
      await this.postRequest(this.submitUrl, this.form);
      this.handleClose();
      this.$emit('refreshList')
    },
    handleOpen() {
      this.form = {...this.selRow}
    },
    handleClose() {
      this.$refs.form.clearValidate();
      this.$emit('update:formVisible', false)
    }
  }
};
